var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.278,
    height: 29,
    viewBox: "0 0 39.278 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comma",
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M0,39.2H9.527c-.163,6.943-2.132,7.731-4.605,7.956l-.954.118V54.9l1.1-.059c3.23-.182,6.8-.764,9.183-3.7,2.088-2.578,3.009-6.79,3.009-13.255V25.9H0Z",
    transform: "translate(0 -25.905)",
    fill: "#ed193a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M111,25.9V39.2h9.4c-.163,6.943-2.068,7.731-4.542,7.956l-.89.118V54.9L116,54.846c3.23-.182,6.832-.764,9.215-3.7,2.088-2.578,3.04-6.79,3.04-13.255V25.9Z",
    transform: "translate(-88.981 -25.905)",
    fill: "#ed193a"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.cdb7e46fb8431c77aaa43bdc87f390d7.svg";
export { ForwardRef as ReactComponent };